import { useEffect, useState } from 'react'
import RouterContext from './RouterContext'
import { RouterContextType } from './types'

const bDebug = false
const preD = 'XXX reactima-router/Router:'

function Router(props) {
  const { history, forceDomain, forceNewWindow, children } = props

  const [location, setLocation] = useState(history.initialLocation)
  const [isMounted, setIsMounted] = useState(false)
  const [pendingLocation, setPendingLocation] = useState(null)

  useEffect(() => {
    bDebug && console.log(`${preD} useEffect ${location.pathname}`, { history, isMounted, location, pendingLocation })
    const unlisten = history.listen((llocation) => {
      if (isMounted) {
        bDebug &&
          console.log(`${preD} history.listen pre setLocation ${llocation.pathname}`, {
            llocation,
            history,
            isMounted,
            location,
            pendingLocation,
          })
        setLocation(llocation)
      } else {
        setPendingLocation(llocation)
      }
    })
    return () => {
      unlisten()
    }
  }, [isMounted, history, location, pendingLocation])

  useEffect(() => {
    setIsMounted(true)

    if (pendingLocation) {
      setLocation(pendingLocation)
    }
  }, [pendingLocation])

  const { pathname } = location
  const match = { path: '/', url: '/', params: {}, isExact: pathname === '/' }

  const value: RouterContextType = {
    name: 'routes',
    history,
    forceDomain,
    forceNewWindow,
    location,
    match,
  }

  bDebug && console.log(`${preD} pre-return ${location.pathname}`, { location, value, children })

  return <RouterContext.Provider value={value}>{children || null}</RouterContext.Provider>
}

export default Router
